import * as React from 'react';

import CampaignAchievementsCard from '../card/CampaignAchievementsCard';

import { __t, applyTranslations } from 'utils/language';

import type { CampaignAchievementMetric } from 'types';

applyTranslations(require('./campaign-achievements-item.i18n.json'));

type Props = {
  type: string,
  entityId?: number,
  imageUrl?: string,
  thumbnailUrl?: string,
  title?: string,
  subtitle?: string,
  metrics?: Array<CampaignAchievementMetric>,
  showDefault?: boolean
};

const CampaignAchievementsItem = (
  {
    type,
    ...props
  }: Props
): JSX.Element => {
  const allProps = { type, ...props };

  return (
    <section className="campaign-achievements-item">
      <h2 className="campaign-achievements-item__title">
        {__t(`campaign_achievements_item.${type}_title`)}
      </h2>
      <CampaignAchievementsCard {...allProps} />
    </section>
  );
};

export default CampaignAchievementsItem;
